import type { FaireProductEntity } from "../../entity_types/product";

export const ramen_1: FaireProductEntity = {
  token: "ramen-1",
  type: "product",
  name: "Original Ramen Noodles",
  brandName: "Public Goods",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/9884fdde5b4b4c2aa26c99febaa7f82d0c64c73beee6f184addfb2ac913f7859.png",
  priceDollars: 5,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/9884fdde5b4b4c2aa26c99febaa7f82d0c64c73beee6f184addfb2ac913f7859.png",
  weight: 0.3,
  dimensions: {
    width: 6,
    height: 8,
    depth: 2,
  },
  description: "Original ramen noodles in a convenient package",
  categoryTokens: ["cat_food-snacks"],
  tags: ["ramen", "instant-ramen", "japanese-ramen", "noodles", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
